export default __webpack_public_path__ + "93e0f7c426663540955d1406faba32e7.png";